<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="8" sm12 xs24 v-for="(sparkline, index) in sparklines" :key="index">
        <card>
          <card-text>
            <sparklines :height="height" :width="width" :color="sparklines[index].progressColor" :stroke-width="strokeWidth" :series="random()" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSparklines',
  mixins: [
    methods
  ],
  data () {
    return {
      sparklines: [],
      strokeWidth: 1,
      height: '64px',
      width: '100%'
    }
  },
  mounted () {
    this.getExternalData('gauge.json', 'sparklines')
  },
  methods: {
    random () {
      const numbers = []
      for (let i = 0; i < 100; i += 1) {
        numbers.push(Math.random() * 100)
      }
      return numbers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/sparklines.vue